(function() {
  if (window.countdownInitialized) return;
  window.countdownInitialized = true;

  document.addEventListener('DOMContentLoaded', function() {
    function initializeCountdowns() {
      const countdownElements = document.querySelectorAll('[data-countdown-timer]:not([data-countdown-initialized])');

      countdownElements.forEach(function(element) {
        const endDate = element.getAttribute('data-date');
        const showHrsMinsSecs = element.getAttribute('data-hrs-mins-secs') === 'true';
        const showDays = element.getAttribute('data-days') === 'true';

        initializeCountdown(element, endDate, showHrsMinsSecs, showDays);
        element.setAttribute('data-countdown-initialized', 'true');
      });
    }

    function initializeCountdown(element, endDate, showHrsMinsSecs, showDays) {
      const targetDate = new Date(endDate);

      function updateCountdown() {
        const now = new Date();
        const pacificTime = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Los_Angeles',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
        }).format(now);
        const pacificNow = new Date(pacificTime);
        
        const distance = targetDate.getTime() - pacificNow.getTime();

        if (distance < 0) {
          element.remove();
          return;
        }

        const totalHours = Math.floor(distance / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        const days = Math.floor(totalHours / 24);
        const useDays = showDays && days > 0;
        const hours = useDays ? totalHours % 24 : totalHours;

        element.setAttribute(
          'aria-label',
          (useDays ? days + ' days ' : '') + hours + ' hours ' + minutes + ' minutes ' + seconds + ' seconds remaining'
        );

        const divider = `
          <div class="countdown-block-divider" aria-hidden="true">
            <span class="countdown-block-value">:</span>
            <span class="countdown-block-label"></span>
          </div>`;

        const daysBlock = useDays ? `
          <div class="countdown-block countdown-block--days">
            <span class="countdown-block-value">${days}</span>
            <span class="countdown-block-label">DAYS</span>
          </div>` + divider : '';

        let countdownText = daysBlock + `
          <div class="countdown-block countdown-block--hours">
            <span class="countdown-block-value">${useDays ? hours.toString().padStart(2, '0') : hours}</span>
            <span class="countdown-block-label">HRS</span>
          </div>` + divider + `
          <div class="countdown-block countdown-block--minutes">
            <span class="countdown-block-value">${minutes.toString().padStart(2, '0')}</span>
            <span class="countdown-block-label">MIN</span>
          </div>` + divider + `
          <div class="countdown-block countdown-block--seconds">
            <span class="countdown-block-value">${seconds.toString().padStart(2, '0')}</span>
            <span class="countdown-block-label">SEC</span>
          </div>`;

        element.innerHTML = countdownText;
      }

      updateCountdown();

      const countdownInterval = setInterval(function() {
        updateCountdown();
        
        const pacificNow = new Date(new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Los_Angeles'
        }).format(new Date()));
        
        if (pacificNow.getTime() > targetDate.getTime()) {
          clearInterval(countdownInterval);
          element.remove();
        }
      }, 1000);
    }

    initializeCountdowns();

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', initializeCountdowns);
      document.addEventListener('shopify:section:unload', initializeCountdowns);
      document.addEventListener('shopify:section:select', initializeCountdowns);
      document.addEventListener('shopify:section:deselect', initializeCountdowns);
      document.addEventListener('shopify:block:select', initializeCountdowns);
      document.addEventListener('shopify:block:deselect', initializeCountdowns);
    }
  });
})();
